import { render } from "./UserDropdown.vue?vue&type=template&id=2d34651d&ts=true"
import script from "./UserDropdown.vue?vue&type=script&lang=ts"
export * from "./UserDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__